<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main.vue'
import dayjs from '@/services/date'
import baseMixin from '@/mixins/baseMixin'
import TheDashboardNavigation from '@/components/layout/the-dashboard-navigation.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Layout,
    TheDashboardNavigation,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
    }),
    compTitle() {
      return 'My Dashboard'
    },
    displayRandomSubtitleGreeting() {
      // Randomised Greetings
      const quotes = [
        `Hi ${this.user?.firstName || ''}, hope you are well`,
        'Glad to have you back!',
        'Welcome back! We missed you!',
        `Hope you're having a great ${dayjs()
          .local()
          .format('dddd')}`,
      ]

      return quotes[Math.floor(Math.random() * quotes.length)]
    },
  },
}
</script>

<template>
  <Layout>
    <v-container>
      <BasePageTitle
        :title="compTitle"
        :subtitle="displayRandomSubtitleGreeting"
        subtitle-on-top
      />
      <v-row>
        <v-col :class="isMobileViewPort ? 'px-0 mx-0' : ''">
          <TheDashboardNavigation />
        </v-col>
      </v-row>
    </v-container>
  </Layout>
</template>
